<template>
  <div class="px-6">
    <div class="button-container my-3">
      <h2 id="returnNoteNumber" class="delivery-number">
        Return Note R{{ returnNoteNumber }} &mdash; {{ currentDate }}
      </h2>
      <div class="right-container">
        <button class="btn-primary btn-save" @click="printContent" style="background-color: blue;">Print</button>
      </div>
    </div>

    <table class="screen-table" style="width:100%; border-collapse: collapse; text-align:center;" v-if="!isLoading && rows.length">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.field" style="border:1px solid #ccc; padding:6px;">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in rows" :key="i">
          <td v-for="col in columns" :key="col.field" style="border:1px solid #ccc; padding:6px;">
            <template v-if="col.field === 'passed' || col.field === 'failed'">/</template>
            <template v-else>{{ row[col.field] != null ? row[col.field] : '' }}</template>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else-if="isLoading">Loading...</div>
    <div v-else>No bags found.</div>
  </div>

  <div id="printable-content" style="display: none;">
    <div class="w-100 to-deliver">
      <table class="print-table" style="border-collapse: collapse; text-align: center; width: 100%;">
        <thead>
          <tr>
            <th colspan="100%">
              <div class="print-header d-flex justify-content-between">
                <div class="col-md-6">
                  <div style="font-weight: bold; font-size: 25px;">Despatched to Trelleborg</div>
                  <div style="font-weight: bold; font-size: 20px;">Return Delivery Note</div>
                  <div id="returnNoteDetails" style="font-size: 16px;">
                    Return Note R{{ returnNoteNumber }}
                    <br/>
                    Date: {{ currentDate }}
                  </div>
                </div>
                <div class="printOnly col-md-6 text-right">
                  <div class="address-logo">
                    <div>
                      <img src="../assets/inspectra-logo-dark.png" alt="Inspectra Logo" class="img-fluid" style="max-width: 100px"/>
                    </div>
                    <div class="address">
                      MRA49B, Marsa Industrial Estate,<br />
                      Marsa.<br />
                      VAT 17434222
                    </div>
                  </div>
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <th v-for="col in columns" :key="col.field" style="border:1px solid black; padding:6px;">
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoading">
            <td :colspan="columns.length" class="text-center">Loading...</td>
          </tr>
          <tr v-else-if="!isLoading && !rows.length">
            <td :colspan="columns.length" class="text-center">No Data Available</td>
          </tr>
          <tr v-for="(row, i) in rows" :key="i" v-else>
            <td v-for="col in columns" :key="col.field" style="border:1px solid black; padding:6px;" :data-field="col.field">
              <template v-if="col.field === 'passed' || col.field === 'failed'">/</template>
              <template v-else>{{ row[col.field] != null ? row[col.field] : '' }}</template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="100%" style="padding-top: 50px;">
              <div style="display: flex;">
                <div class="footer-text" style="flex: 1; margin: 0 10px; border-top: 1px solid black; text-align: center;">Delivered on time By</div>
                <div class="footer-text" style="flex: 1; margin: 0 10px; border-top: 1px solid black; text-align: center;">Checked by</div>
                <div class="footer-text" style="flex: 1; margin: 0 10px; border-top: 1px solid black; text-align: center;">Received on time By</div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { useBagInventoryStore } from '@/stores/bagInventory.js';
import { useToast } from 'vue-toast-notification';
const $toast = useToast();

export default {
  name: 'ReturnToSupplierNote',
  data() {
    return {
      isLoading: false,
      rows: [],
      returnNoteNumber: '',
      currentDate: new Date().toLocaleDateString('en-GB'),
      columns: [
        { label: 'Bag No',          field: 'bagNumber' },
        { label: 'MO Number',       field: 'moNumber' },
        { label: 'Chit Number',     field: 'chitNumber' },
        { label: 'Part Number',     field: 'partNumber' },
        { label: 'Supplier',        field: 'supplier' },
        { label: 'Inspection Type', field: 'inspectionType' },
        { label: 'Issued',          field: 'quantityIssued' },
        { label: 'Passed',          field: 'passed' },
        { label: 'Failed',          field: 'failed' },
      ],
    };
  },
  async mounted() {
    this.returnNoteNumber = this.$route.query.noteNumber || '';
    const idsParam = this.$route.params.ids;
    if (!idsParam) return;

    const ids = idsParam.split(',').map(Number).filter(Boolean);
    if (!ids.length) return;

    this.isLoading = true;
    const bagInventoryStore = useBagInventoryStore();
    const response = await bagInventoryStore.getBagsByIds(ids);
    if (response && response.ok) {
      const data = await response.json();
      this.rows = data.sort((a, b) => {
        if (a.bagNumber < b.bagNumber) return -1;
        if (a.bagNumber > b.bagNumber) return 1;
        return 0;
      });
    } else {
      $toast.error('Failed to load bag details');
    }
    this.isLoading = false;
  },
  methods: {
    printContent() {
      const printContents = document.getElementById('printable-content').innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      document.body.pageSize = 'A4';
      document.body.style.fontSize = '12px';
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
#printable-content {
  display: none;
}
@media print {
  @page { size: landscape; margin: 10mm; }
}
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}
.delivery-number {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
